// ═══ 차량/서류 공통 상수 — 상태 흐름 + 색상 + 서류 라벨 ═══
// CarList, CarListTable, DashboardPage, DocumentUpload 등에서 중복 정의 통합

// 차량 상태 7단계 (등록완료 → 선적완료)
var FLOW = ['등록완료','말소신청','말소완료','면장신청','면장완료','선적대기','선적완료'];

// FLOW와 1:1 매칭되는 색상
var FLOW_COLOR = ['#6366f1','#f59e0b','#10b981','#3b82f6','#8b5cf6','#f97316','#22c55e'];

// 서류 docType → 한글 라벨 (다운로드/모달/툴바 공용)
var DOC_NAMES = {
  malso: '말소신청서',
  contract: '매매계약서',
  nonbiz: '비사업용확인서',
  pumui: '품의서',
  malsoCert: '말소증',
  myunjang: '수출면장',
  tax_invoice: '세금계산서',
  purchase_confirm: '구매확인서',
  registration: '자동차등록증',
  salesContract: '현장계약서'
};

export { FLOW, FLOW_COLOR, DOC_NAMES };
